import { render, staticRenderFns } from "./MdContactUs.vue?vue&type=template&id=4b39f4fa&scoped=true&"
import script from "./MdContactUs.vue?vue&type=script&lang=js&"
export * from "./MdContactUs.vue?vue&type=script&lang=js&"
import style0 from "./MdContactUs.vue?vue&type=style&index=0&id=4b39f4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39f4fa",
  null
  
)

export default component.exports